import { GpsOff, AccessTime } from '@mui/icons-material';
import { flagEmojiString } from './FlagsWithGeoAddr';
import { fullDateNoSecond } from '@/utilities/dateUtils';
import { useTranslation } from 'react-i18next';
import './TokenFail.css';

type LanguageEntry = {
  iso2: string;
  message: string;
  flag: string;
};

const languages: LanguageEntry[] = [
  { iso2: 'hu', message: 'A hozzáférésre pillanatnyilag nem jogosult.', flag: 'hu' },
  { iso2: 'en', message: 'You are currently not authorized to access.', flag: 'gb' },
  { iso2: 'hr', message: 'Vaš pristup je trenutno onemogućen.', flag: 'hr' },
  { iso2: 'ro', message: 'Valabilitatea accesului a expirat.', flag: 'ro' },
  { iso2: 'sr', message: 'Vreme dozvoljenog pristupa isteklo.', flag: 'rs' },
  { iso2: 'sk', message: 'Momentálne nemáte oprávnenie na prístup.', flag: 'sk' },
  { iso2: 'de', message: 'Sie sind derzeit nicht zugriffsberechtigt.', flag: 'de' },
  { iso2: 'fr', message: "Votre accès n'est pas disponible pour le moment.", flag: 'fr' },
  { iso2: 'es', message: 'De momento, su acceso no está autorizado.', flag: 'es' },
  { iso2: 'nl', message: 'U bent momenteel niet gemachtigd tot toegang.', flag: 'nl' },
  { iso2: 'sv', message: 'Du är för tillfället ej behörig för åtkomst.', flag: 'se' },
];

function getBrowserLang(): string {
  return navigator.language.slice(0, 2).toLowerCase();
}

export function TokenFail() {
  const browserLang = getBrowserLang();
  const params = new URLSearchParams(window.location.search);
  const fromTimestamp = params.get('from');
  const toTimestamp = params.get('to');
  const { t } = useTranslation();

  const fromTime = fromTimestamp ? fullDateNoSecond(parseInt(fromTimestamp), t) : null;
  const toTime = toTimestamp ? fullDateNoSecond(parseInt(toTimestamp), t) : null;

  const sortedLanguages = languages.sort((a, b) => (a.iso2 === browserLang ? -1 : b.iso2 === browserLang ? 1 : 0));

  return (
    <div className="token-fail-container">
      <div className="token-fail-header">
        <a href="https://www.itrack.hu">
          <img src="svg/iTrack-white_ez.svg" className="token-fail-logo" />
        </a>
        {fromTimestamp && toTimestamp && (
          <div className="token-fail-validity">
            <AccessTime sx={{ fontSize: 16, verticalAlign: 'middle', marginRight: '4px' }} color={'secondary'} />
            <span>
              {fromTime && <> {fromTime} </>}
              {fromTime && toTime && ' – '}
              {toTime && <> {toTime} </>}
            </span>
          </div>
        )}
      </div>
      <div className="token-fail-messages">
        {sortedLanguages.map(({ iso2, message, flag }) => (
          <p key={iso2} className={`token-fail-message-row ${iso2 === browserLang ? 'highlight' : ''}`}>
            <span className="token-fail-message">
              <span className="token-fail-message-flag">{flagEmojiString(flag)}</span>
              <span className="token-fail-message-text">{message}</span>
            </span>
            <GpsOff
              sx={{ fontSize: 20, padding: '2px', marginLeft: '5px' }}
              color={iso2 === browserLang ? 'secondary' : 'disabled'}
            />
          </p>
        ))}
      </div>
    </div>
  );
}
